import { faqs } from '@/mocks/testimonials';

export default function FAQSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于八仔漫画网，你想知道的都在这里
        </p>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-lg overflow-hidden">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer select-none">
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-300 group-open:rotate-180">
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}